<div class="analytics-filter-container">
    <div class="filter-row">
        <mat-form-field appearance="outline" class="filter-field">
            <mat-label>Date Range</mat-label>
            <input matInput  [matDatepicker]="startPicker"
                [(ngModel)]="startDate" (dateChange)="onFilterChange()" placeholder="Start Date">
            <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
            <mat-datepicker #startPicker></mat-datepicker>
        </mat-form-field>

        <mat-form-field appearance="outline" class="filter-field">
            <mat-label>To</mat-label>
            <input matInput [matDatepicker]="endPicker" [(ngModel)]="endDate"
                (dateChange)="onFilterChange()" placeholder="End Date">
            <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
            <mat-datepicker #endPicker></mat-datepicker>
        </mat-form-field>

        <mat-form-field appearance="outline" class="filter-field" *ngIf="categories.length > 0">
            <mat-label>Category</mat-label>
            <mat-select [(ngModel)]="selectedCategory" (selectionChange)="onFilterChange()">
                <mat-option value="">All Categories</mat-option>
                <mat-option *ngFor="let cat of categories" [value]="cat">
                    {{ cat }}
                </mat-option>
            </mat-select>
        </mat-form-field>

        <div class="filter-buttons">
            <button mat-stroked-button color="primary" (click)="onFilterChange()">
                <mat-icon>filter_list</mat-icon>
                Apply
            </button>
            <button mat-stroked-button (click)="resetFilters()">
                <mat-icon>clear</mat-icon>
                Reset
            </button>
        </div>
    </div>
</div>